import React from 'react';

export interface SidebarInfoRow {
  key: string;
  label: string;
  value: React.ReactNode;
}

interface SidebarInfoCardProps {
  title: string;
  rows: SidebarInfoRow[];
  className?: string;
}

const SidebarInfoCard: React.FC<SidebarInfoCardProps> = ({
  title,
  rows,
  className,
}) => {
  if (rows.length === 0) return null;

  return (
    <div className={`gxp-card gxp-sidebar-card ${className ?? ''}`}>
      <div className='gxp-card__title'>{title}</div>
      <div className='gxp-sidebar-card__list'>
        {rows.map((row) => (
          <div className='gxp-sidebar-card__row' key={row?.key}>
            <div className='gxp-sidebar-card__label'>{row?.label}</div>
            <div className='gxp-sidebar-card__value'>{row?.value}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SidebarInfoCard;
